import InvoiceFeeItem from './InvoiceFeeItem.view';

export default InvoiceFeeItem;
